// F8M Content Studio — frontend constants.
// Source of truth: docs/specs/02-VARIABLE-REGISTRY.md

// ─── API ──────────────────────────────────────────────────────────────────
export const API_BASE = '/api/v1';

// ─── Platforms ────────────────────────────────────────────────────────────
export const PLATFORM_LINKEDIN  = 'linkedin';
export const PLATFORM_INSTAGRAM = 'instagram';
export const PLATFORM_FACEBOOK  = 'facebook';
export const PLATFORM_YOUTUBE   = 'youtube';

export const PLATFORMS = [
  PLATFORM_LINKEDIN,
  PLATFORM_INSTAGRAM,
  PLATFORM_FACEBOOK,
  PLATFORM_YOUTUBE,
];

// ─── Caption character limits ─────────────────────────────────────────────
export const MAX_LINKEDIN  = 3000;
export const MAX_INSTAGRAM = 2200;
export const MAX_FACEBOOK  = 63206;
export const MAX_YOUTUBE   = 5000;

export const CHAR_LIMITS = {
  [PLATFORM_LINKEDIN]:  MAX_LINKEDIN,
  [PLATFORM_INSTAGRAM]: MAX_INSTAGRAM,
  [PLATFORM_FACEBOOK]:  MAX_FACEBOOK,
  [PLATFORM_YOUTUBE]:   MAX_YOUTUBE,
};

// ─── Fold points (where the platform truncates with "…more") ──────────────
export const LINKEDIN_FOLD  = 210;
export const INSTAGRAM_FOLD = 125;
export const FACEBOOK_FOLD  = 477;

export const FOLD_POINTS = {
  [PLATFORM_LINKEDIN]:  LINKEDIN_FOLD,
  [PLATFORM_INSTAGRAM]: INSTAGRAM_FOLD,
  [PLATFORM_FACEBOOK]:  FACEBOOK_FOLD,
};

// ─── Ad limits ────────────────────────────────────────────────────────────
export const MAX_HEADLINE_GOOGLE    = 30;
export const MAX_DESCRIPTION_GOOGLE = 90;
export const MAX_HEADLINE_META      = 40;

// ─── Draft statuses ───────────────────────────────────────────────────────
export const STATUS_DRAFT     = 'draft';
export const STATUS_PENDING   = 'pending_approval';
export const STATUS_APPROVED  = 'approved';
export const STATUS_SCHEDULED = 'scheduled';
export const STATUS_PUBLISHED = 'published';
export const STATUS_REJECTED  = 'rejected';

export const DRAFT_STATUSES = [
  STATUS_DRAFT,
  STATUS_PENDING,
  STATUS_APPROVED,
  STATUS_SCHEDULED,
  STATUS_PUBLISHED,
  STATUS_REJECTED,
];

// ─── Event statuses ───────────────────────────────────────────────────────
export const EVENT_DRAFT     = 'draft';
export const EVENT_CONFIRMED = 'confirmed';
export const EVENT_CANCELLED = 'cancelled';
export const EVENT_ARCHIVED  = 'archived';
export const EVENT_COMPLETED = 'completed';

export const EVENT_STATUSES = [
  EVENT_DRAFT,
  EVENT_CONFIRMED,
  EVENT_CANCELLED,
  EVENT_ARCHIVED,
  EVENT_COMPLETED,
];

// ─── Content types ────────────────────────────────────────────────────────
export const TYPE_POST     = 'post';
export const TYPE_CAROUSEL = 'carousel';
export const TYPE_REEL     = 'reel_script';
export const TYPE_STORY    = 'story';
export const TYPE_ARTICLE  = 'article';

// ─── Content phases ───────────────────────────────────────────────────────
export const PHASE_PRE        = 'pre_event';
export const PHASE_DURING     = 'during_event';
export const PHASE_POST       = 'post_event';
export const PHASE_STANDALONE = 'standalone';

// ─── Tones ────────────────────────────────────────────────────────────────
export const TONE_CELEBRATORY    = 'celebratory';
export const TONE_REFLECTIVE     = 'reflective';
export const TONE_URGENT         = 'urgent';
export const TONE_INFORMATIONAL  = 'informational';
export const TONE_PERSONAL       = 'personal';

export const TONES = [
  TONE_CELEBRATORY,
  TONE_REFLECTIVE,
  TONE_URGENT,
  TONE_INFORMATIONAL,
  TONE_PERSONAL,
];

// ─── Roles ────────────────────────────────────────────────────────────────
export const ROLE_ADMIN   = 'admin';
export const ROLE_CREATOR = 'creator';

// ─── People types ─────────────────────────────────────────────────────────
export const PERSON_TEAM     = 'team';
export const PERSON_PARTNER  = 'partner';
export const PERSON_EXTERNAL = 'external';

// ─── Languages ────────────────────────────────────────────────────────────
export const LANGUAGE_EN = 'en';
export const LANGUAGE_PL = 'pl';
export const LANGUAGES = [LANGUAGE_EN, LANGUAGE_PL];

// ─── File limits ──────────────────────────────────────────────────────────
export const MAX_IMAGE_SIZE_BYTES = 25  * 1024 * 1024;  // 25MB
export const MAX_VIDEO_SIZE_BYTES = 100 * 1024 * 1024;  // 100MB
export const MAX_FILENAME_SEGMENT = 50;

// ─── AI budgeting ─────────────────────────────────────────────────────────
export const DAILY_AI_BUDGET = 900;
